import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@mui/material';
import AltaDiaFestivo from './Percepcion/AltaDiaFestivo';
import AltaGratificacion from './Percepcion/AltaGratificacion';
import AltaConpensacion from './Percepcion/AltaConpensacion';

const AltaPercepcion = (props) => {
    const dispatch = useDispatch()
    const [tipo, setTipo] = React.useState('');

    const { lote } = props
    const { periodo } = props
    const { idempleado } = props
    const { activarbotontab } = props
    const { notificacion } = props

    const { datotodoempleado } = props
    const { obtenerdatolote } = props

    const percepcion = useSelector(store => store.menus.percepciones)

    const handleChange = (event) => {
        setTipo(event.target.value);
    };


    return (
        <>
            <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={tipo}
                    label="Tipo"
                    onChange={handleChange}
                >
                    {
                        percepcion.map((row, Index) =>
                            <MenuItem key={Index} value={row.idconcepto}>{row.descripcion}</MenuItem>
                        )
                    }

                </Select>
            </FormControl>
            {
                tipo === 12 ? (
                    <AltaDiaFestivo
                        idempleado={idempleado}
                        lote={lote}
                        periodo={periodo}
                        activarbotontab={activarbotontab}
                        notificacion={notificacion}
                        idconcepto={tipo}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null
            }
            {
                tipo === 13 ? (
                    <AltaGratificacion
                        idempleado={idempleado}
                        lote={lote}
                        periodo={periodo}
                        notificacion={notificacion}
                        idconcepto={tipo}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null
            }
            {
                tipo === 14 ? (
                    <AltaConpensacion
                        idempleado={idempleado}
                        lote={lote}
                        periodo={periodo}
                        notificacion={notificacion}
                        idconcepto={tipo}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null
            }
        </>
    )
}

export default AltaPercepcion